import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2d2ef87c&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d2ef87c')) {
      api.createRecord('2d2ef87c', component.options)
    } else {
      api.reload('2d2ef87c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2d2ef87c&", function () {
      api.rerender('2d2ef87c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/calculation-sheets/components/google/index.vue"
export default component.exports